import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "md:px-14 my-10 flex flex-col justify-start w-full" }
const _hoisted_2 = { class: "grid grid-cols-12 gap-5 bg-white p-5 md:p-8 rounded-md shadow-md" }
const _hoisted_3 = { class: "col-span-12" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "text-lg md:text-2xl" }
const _hoisted_6 = { class: "col-span-12 flex items-center gap-8 flex-wrap" }
const _hoisted_7 = { class: "flex gap-5" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "col-span-12 md:col-span-6 flex items-center gap-3" }
const _hoisted_10 = { class: "text-gray-400 text-sm w-72" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPermissionBrowser = _resolveComponent("ModalPermissionBrowser")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showModalPermissionBrowser)
      ? (_openBlock(), _createBlock(_component_ModalPermissionBrowser, {
          key: 0,
          showModalPermissionBrowser: _ctx.showModalPermissionBrowser,
          onOnCloseModalPermissionBrowser: _ctx.closeModalPermissionBrowser
        }, null, 8, ["showModalPermissionBrowser", "onOnCloseModalPermissionBrowser"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Detecção de atenção",
                en: "Detect attention",
              })), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.switchers, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex gap-8 items-center"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(item.name), 1),
                _createVNode(_component_InputSwitch, {
                  modelValue: item.selected,
                  "onUpdate:modelValue": ($event: any) => ((item.selected) = $event),
                  onChange: ($event: any) => (item.action(i))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ])
            ]))
          }), 128)),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_icon, {
              name: "hi-information-circle",
              scale: 2,
              class: "text-gray-400"
            }),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Ao desativar a detecção de atenção, você pode perder o foco nos seus estudos.",
                en: "By turning attention detection off, you may lose focus on your studies.",
              })), 1)
          ])
        ])
      ])
    ])
  ], 64))
}